import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

export function errorInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  return next(request).pipe(
    catchError((err) => {
      console.log(err);
      switch (err.status) {
        case 401:
          console.log('---- 401 from ErrorService HttpInterceptor ');
          return throwError({ subType: '401', message: err.message, request });
          break;
        case 0:
          //try offline methode if case = 0 ( '0' error may be ERR_INTERNET_DISCONNECTED return)
          return throwError({ subType: '0', message: err.message, request });
          break;
        default:
          let errorMsg = 'no details';
          if (err.error != null && err.error != '') errorMsg = err.error;
          return throwError({
            subType: err.status,
            message: err.message,
            error: errorMsg,
            request,
          });
          break;
      }
    }),
  );
}
